import api from "../../lib/api";

export default {
  namespaced: true,
  state: {
    list: [],
    loading: false,
    posting: false,
    isAddOrEdit: false,
    statusing: false,
    company: {
      id: 0,
      name: "",
      order: 0,
      prefix: "",
      logo: null,
      status: true,
      category_id: 0
    }
  },
  mutations: {
    SET_COMPANY(state, company) {
      state.company = company;
    },
    SET_CATEGORIES(state, companies) {
      state.list = companies;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_POSTING(state, posting) {
      state.posting = posting;
    },
    SET_IS_ADD_OR_EDIT(state, isAddOrEdit) {
      if (!isAddOrEdit)
        state.company = {
          id: 0,
          name: "",
          order: 0,
          prefix: "",
          logo: null,
          status: true,
          category_id: 0
        };
      state.isAddOrEdit = isAddOrEdit;
    },
    SET_STATUSING(state, statusing) {
      state.statusing = statusing;
    },
    RESET_COMPANY(state) {
      state.company = {
        id: 0,
        name: "",
        order: 0,
        prefix: "",
        logo: null,
        status: true,
        category_id: 0
      };
    }
  },
  actions: {
    setLoading({ commit }, loading) {
      commit("SET_LOADING", loading);
    },
    setIsAddOrEdit({ commit }, isAddOrEdit) {
      if (!isAddOrEdit) commit("RESET_COMPANY");
      commit("SET_IS_ADD_OR_EDIT", isAddOrEdit);
    },
    async getCompanyById({}, id) {
      const response = await api.get(`/companies/${id}`);
      return response.data;
    },
    async editCompany({ dispatch, commit }, id) {
      commit("SET_COMPANY", await dispatch("getCompanyById", id));
      commit("SET_IS_ADD_OR_EDIT", true);
    },
    async toggleStatus({ dispatch, commit }, company) {
      commit("SET_STATUSING", true);
      await api.patch(`/companies/${company.id}`, {
        status: !company.status
      });
      await dispatch("getCompanies", { bypass: true });
      commit("SET_STATUSING", false);
    },
    async getCompanies({ commit }, { bypass = false } = {}) {
      if (!bypass) commit("SET_LOADING", true);
      const response = await api.get("/companies");
      response.data.sort((a, b) => a.order - b.order);
      commit("SET_CATEGORIES", response.data);
      if (!bypass) commit("SET_LOADING", false);
    },
    async saveCompany({ dispatch, commit }, company) {
      commit("SET_POSTING", true);
      let data;
      let contentType = "application/json";
      if (company.logo) {
        contentType = "multipart/form-data";
        let formData = new FormData();
        Object.entries(company).forEach(([key, value]) => {
          if (key === "logo") return;
          formData.append(`company[${key}]`, value);
        });
        formData.append("company[logo]", company.logo);
        data = formData;
      } else {
        data = { company };
      }
      try {
        if (company.id === 0) {
          await api.post("/companies", data, {
            headers: {
              "Content-Type": contentType
            }
          });
        } else {
          await api.put(`/companies/${company.id}`, data, {
            headers: {
              "Content-Type": contentType
            }
          });
        }
        await dispatch("getCompanies");
        commit("SET_POSTING", false);
        commit("SET_IS_ADD_OR_EDIT", false);
        commit("RESET_COMPANY");
      } catch (error) {
        commit("SET_POSTING", false);
      }
    },
    async deleteCompany({ dispatch }, id) {
      await api.delete(`/companies/${id}`);
      await dispatch("getCompanies");
    },
    async updateOrder({ dispatch }, company) {
      if (company.order != 0) {
        await api.put(`/companies/${company.id}`, company);
        await dispatch("getCompanies", { bypass: true });
      }
    }
  },
  getters: {
    company: state => state.company,
    companies: state => state.list,
    loading: state => state.loading,
    posting: state => state.posting,
    isAddOrEdit: state => state.isAddOrEdit,
    statusing: state => state.statusing
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/company.js